import React, { useCallback } from "react";

// Components
import CountControll from "components/CountControll";

// Lib
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// Actions
import { decrement, incriment } from "../reducer";

export const TotalAmount: React.FC = () => {
  const dispatch = useAppDispatch();

  const { count, price, disabled } = useAppSelector(
    (store) => ({
      count: store.moleculeProduct.count,
      price: store.moleculeProduct.price, 
      disabled: store.moleculeProduct.disabled
    }),
    shallowEqual
  );

  const handlerClickMinus = useCallback(() => {
    dispatch(decrement(count));
  }, [count]);

  const handlerClickPlus = useCallback(() => {
    dispatch(incriment(count));
  }, [count]);

  const totalAmount = count * price;

  return (
    <div className="count-controller flex flex-ai-start full-width">
      <CountControll
        className="mr10"
        innerCount={count}
        innderDisabled={disabled}
        handlerPlus={handlerClickPlus}
        handlerMinus={handlerClickMinus}
      />

      <div className="count-controller__right-block">
        <p className="count-controller__label mb15">Total amount</p>
        <p className="count-controller__total-price">{totalAmount}</p>
      </div>
    </div>
  );
};

export default TotalAmount;